import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  TablePagination,
  useTheme,
  Card,
  CardContent,
  Avatar,
  Button,
  MenuItem,
  TextField
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Cookies from 'js-cookie';
import { GetAllUser, getSummaryUserData, SearchUserData } from '../../../../service/user_service';
import { AlertError } from '../../../../component/popupAlert';
import { alpha } from '@mui/material/styles';
import { BsPersonFill } from "react-icons/bs";
import { MdPreview } from "react-icons/md";
import ResponsiveAppBar from '../../../../component/appbar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// Styled components for the table
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-head': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  '&.MuiTableCell-body': {
    fontSize: 14,
    borderBottom: '1px solid #ddd',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}));

const EmployeeDashboard = () => {
  const navigate = useNavigate();
  const [employeeAccount, setEmployeeAccount] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const token = Cookies.get('token');
  const [isLoading, setIsLoading] = useState(true);
  const [summaryUser, setSumaryUser] = useState([]);
  const initialData = { first_name: '', username: '', role: '', }

  const [searchData, setSearchData] = useState(initialData);

  useEffect(() => {
    handleGetEmployeeAccount();
    handleGetSummary();
  }, []);


  const handleReset_s = async () => {
    setSearchData(initialData);
  }

  const handleChang_s = (e, fieldName) => {
    if (e && e.target) {
      // Handle TextField or MenuItem
      const { name, value } = e.target;
      setSearchData(prevData => ({
        ...prevData,
        [name]: value
      }));
    } else if (fieldName) {
      // Handle DateTimePicker or custom field
      setSearchData(prevData => ({
        ...prevData,
        [fieldName]: e // e in this case is the date value
      }));
    }
  };

  const handleSearch = async (data) => {
    console.log("Search", data)
    try{
      const res = await SearchUserData(data,token)
      setEmployeeAccount(res);
      console.log("res",res)
    }catch(error){
      console.error("Error fetching employee account:", error);
      AlertError('เกิดข้อผิดพลาดในการค้นหาผู้ใช้');
    }
  }

  const StatusCard = ({ title, count, icon, color , onClick }) => {
    const theme = useTheme();

    return (
      <Card
        sx={{
          backgroundColor: 'white',
          height: '100%',
          borderRadius: 4,
          position: 'relative',
          overflow: 'hidden',
          transition: 'transform 0.3s, box-shadow 0.3s',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: theme.shadows[10],
          },
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '100%',
            background: `linear-gradient(45deg, ${alpha(color, 0.2)}, ${alpha(color, 0.1)})`,
            zIndex: 0,
          }}
        />
        <CardContent
          sx={{
            position: 'relative',
            zIndex: 1,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            p: 3,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
            <Box>
              <Avatar
                sx={{
                  bgcolor: color,
                  width: 52,
                  height: 52,
                  boxShadow: `0 4px 20px ${alpha(color, 0.5)}`,
                }}
              >
                {icon}
              </Avatar>
              <Typography
                variant="h6"
                marginTop={'18px'}
                sx={{
                  fontWeight: 'medium',
                  color: theme.palette.text.secondary,
                }}
              >
                {title}
              </Typography>
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 'bold',
                color: theme.palette.text.primary,
              }}
            >
              {count}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  };

  const getStatusCount = (role) => {
    const item = summaryUser.find(item => item.role === role);
    return item ? item.user_count : 0;
  };

  const handleGetEmployeeAccount = async () => {
    try {
      setIsLoading(true);
      const res = await GetAllUser(token);
      setEmployeeAccount(res);
    } catch (error) {
      AlertError('เกิดข้อผิดพลาดในการดึงข้อมูล');
    } finally {
      setIsLoading(false);
    }
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleGetSummary = async () => {
    try {
      const res = await getSummaryUserData(token);
      setSumaryUser(res);
    } catch (error) {
      console.error(error);
      navigate('/404');
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <ResponsiveAppBar />
      <Box sx={{ flexGrow: 1, p: 3, margin: 4 }}>
        <Typography variant="h4" gutterBottom>
          Employee Dashboard
        </Typography>
        <Grid container spacing={2} sx={{ mb: 3, marginTop: '10px' }}>
          <Grid item xs={12} md={3}>
            <StatusCard
              title="จำนวนพนักงานทั้งหมด"
              count={getStatusCount("ทั้งหมด")}
              icon={<BsPersonFill />}
              color="#3f51b5"
              onClick={(e)=>{handleSearch({})}}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <StatusCard
              title="ผู้ดูแลระบบ"
              count={getStatusCount("System Admin")}
              icon={<BsPersonFill />}
              color="#4caf50"
              onClick={(e)=>{handleSearch({role:'System Admin'})}}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <StatusCard
              title="ฝ่าย Sales"
              count={getStatusCount("Sales")}
              icon={<BsPersonFill />}
              color="#ff9800"
              onClick={(e)=>{handleSearch({role:'Sales'})}}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <StatusCard
              title="พนักงาน"
              count={getStatusCount("Common")}
              icon={<BsPersonFill />}
              color="#f44336"
              onClick={(e)=>{handleSearch({role:'Common'})}}
            />
          </Grid>
        </Grid>

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
          <Card sx={{ padding: 3, marginTop: 1, marginBottom: 3 }}>
            <Typography variant="h6" gutterBottom>
              ค้นหารายชื่อพนักงาน
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>หมายเลขพนักงาน</Typography>
                <TextField
                  name="username"
                  label="หมายเลขพนักงาน"
                  value={searchData.roombooking_id}
                  onChange={handleChang_s}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>ชื่อจริง</Typography>
                <TextField
                  name="first_name"
                  label="ชื่อจริง"
                  value={searchData.first_name}
                  onChange={handleChang_s}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>สิทธิ์การใช้งาน</Typography>
                <TextField
                  select
                  name="role"
                  label="สิทธิ์การใช้งาน"
                  value={searchData.role}
                  onChange={handleChang_s}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                >
                  <MenuItem value="Sales">Sales</MenuItem>
                  <MenuItem value="System Admin">System Admin</MenuItem>
                  <MenuItem value="Common">Common</MenuItem>
                </TextField>
              </Grid>

            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant="outlined"
                color="primary"
                sx={{ marginRight: 2, width: '200px' }}
                onClick={handleReset_s}
              >
                ล้างค่า
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ width: '200px' }}
                onClick={() => handleSearch(searchData)}
              >
                ค้นหา
              </Button>
            </Box>
          </Card>
        </LocalizationProvider>

        {/* Employee List Table */}
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <Typography variant="h6" gutterBottom>
                รายการชื่อพนักงาน
              </Typography>
              <Button variant="contained" onClick={() => navigate('/thewonderblueadmin_register')} sx={{ width: '200px' }}>
                เพิ่มพนักงาน
              </Button>
            </Box>
            <Grid container spacing={3}>
              {employeeAccount && (
                <Grid item xs={12}>
                  <Paper>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>ลำดับ</StyledTableCell>
                            <StyledTableCell>รหัสพนักงาน</StyledTableCell>
                            <StyledTableCell>ชื่อ</StyledTableCell>
                            <StyledTableCell>อีเมล</StyledTableCell>
                            <StyledTableCell>เบอร์โทรศัพท์</StyledTableCell>
                            <StyledTableCell>ตำแหน่ง</StyledTableCell>
                            <StyledTableCell>รายละเอียด</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {employeeAccount
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((employee, index) => (
                              <StyledTableRow key={employee.id}>
                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                <TableCell>{employee.username}</TableCell>
                                <TableCell>{employee.first_name} {employee.last_name}</TableCell>
                                <TableCell>{employee.email}</TableCell>
                                <TableCell>{employee.tel}</TableCell>
                                <TableCell>{employee.role}</TableCell>
                                <StyledTableCell>
                                  <Button
                                    size="medium"
                                    onClick={() => navigate('/thewonderblueadmin_employee/view/' + employee.user_id)}
                                  >
                                    <MdPreview fontSize={'24px'} color='gray' />
                                  </Button>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      component="div"
                      count={employeeAccount.length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      rowsPerPageOptions={[20]}
                      labelRowsPerPage="จำนวนรายการต่อหน้า"
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} จาก ${count}`}
                    />
                  </Paper>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default EmployeeDashboard;
